import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ISampleCorrectionView } from '../interfaces/sample-correction-view';
import { Observable } from 'rxjs';
import { ICreateSampleCorrectionCommand } from '../interfaces/create-sample-correction-command';

@Injectable({
  providedIn: 'root'
})
export class SampleCorrectionService {
  private rootUrl: string = "/api/sample-corrections";
  private storageKey: string = "CurrentPreLog";

  constructor(private httpClient: HttpClient) { }

  public getCreateView(tempId: string): Observable<ISampleCorrectionView> {
    const url = this.rootUrl + "/" + tempId;
    return this.httpClient.get<ISampleCorrectionView>(url);
  }

  public create(command: ICreateSampleCorrectionCommand): Observable<any> {
    return this.httpClient.post(this.rootUrl, command);
  }
}
